import React, { useMemo } from 'react';
import StyledBox from 'views/membership-module/MembershipView/components/PlanSection/PlanSection.styles';
import { Typography700 } from 'views/common/components';
import { Box, Button, Typography } from '@mui/material';
import Typography500 from 'views/common/components/UI/Typography500';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import { useTranslation } from 'next-i18next';
import PATHS from 'lib/navigation/paths';

const PlanSection = (props) => {
  const { membershipData, getSubscribeNowPath } = props;
  const { t } = useTranslation('fe_er_membership_page');
  const benfites = useMemo(
    () => [
      t('fe_er_membership_page:plan_benfits.rental_credits', {
        rental_count: membershipData.rental_credits_count,
        ride_days: membershipData.rental_credits_count,
      }),
      t('fe_er_membership_page:plan_benfits.additional_riding', {
        value: membershipData.pl_rental_discount,
      }),
      t('fe_er_membership_page:plan_benfits.rollover', { count: 18 }),
      t('fe_er_membership_page:plan_benfits.brands'),
      t('fe_er_membership_page:plan_benfits.destinations', { value: 100 }),
      t('fe_er_membership_page:plan_benfits.gift'),
    ],
    [membershipData.rental_credits_count, membershipData.pl_rental_discount],
  );
  return (
    <StyledBox darg>
      <Typography700 component="p" className="PSTitle">
        {t('fe_er_membership_page:no_hassel')}
        <Typography700 component="span" className="PSTitle PSTitleHint">
          {membershipData.name}
        </Typography700>
      </Typography700>
      <Box className="PSPlanCard">
        <Box className="PSPlanItem">
          <Typography700 variant="h3" className="PSPlanTitle">
            {membershipData.name}
          </Typography700>
          <Typography className="PSPricePerMonth">
            <Typography700 component="span" className="PSPrice">
              {membershipData.monthly_price}
              <Typography700 component="span" className="PSPriceStar">
                *
              </Typography700>
            </Typography700>
            /
            {t('fe_er_membership_page:month')}
          </Typography>
          <Button
            href={getSubscribeNowPath()}
            variant="contained"
            className="PSBtn"
            component={NavigatorLink}>
            {t('fe_er_membership_page:subscribe_now')}
          </Button>
        </Box>
        <Box className="PSBenfites">
          {benfites.map((item) => (
            <Typography500
              component="p"
              variant="body1"
              className="PSBenfiteItem"
              key={item}>
              {item}
            </Typography500>
          ))}
        </Box>
      </Box>
      <Typography variant="caption" className="PSNote" component="p">
        {t('fe_er_membership_page:price_excludes_insurance', {
          count: membershipData.term_months,
        })}
      </Typography>
      <Button
        href={PATHS.motorcycleClub.index()}
        variant="text"
        className="PSCompareBtn"
        component={NavigatorLink}>
        <Typography700 component="span" className="PSCompareBtnText">
          {t('fe_er_membership_page:compare_other_ways')}
          <OpenInNewIcon className="PSCompareBtnIcon" />
        </Typography700>
      </Button>
    </StyledBox>
  );
};

export { PlanSection };
